<template>
  <span class="rich-text-wrapper">
    <!-- html字符串 -->
    <span v-if="type === 2" class="v-html" v-html="content"></span>

    <!-- 纯文本 -->
    <span v-else>{{ content }}</span>
  </span>
</template>

<script>
export default {
  name: 'RichText',

  props: {
    type: {
      type: Number,
      default: 1,
    },
    content: {
      type: String,
      default: '', // '<p><img src="" alt="" /></p>'
    },
  },
};
</script>

<style scoped>
.rich-text-wrapper span {
  font-size: 16px !important;
  word-break: break-all;
}
.v-html /deep/ img {
  width: 100%;
  border-radius: 8px;
}
</style>
